<div
  *transloco="let t; read: 'shared.statusBar'"
  [matTooltip]="t('hints.notAvailableForRfq')"
  [matTooltipDisabled]="tooltipDisabled()"
>
  <button
    mat-flat-button
    class="!mr-4 text-label-large"
    [disabled]="buttonDisabled()"
    [routerLink]="['/detail', 'bom']"
    queryParamsHandling="merge"
    (click)="loadBom()"
  >
    {{ t('loadBom') }}
  </button>
</div>
